import { render } from "./save-block.vue?vue&type=template&id=6b2743ce&ts=true"
import script from "./save-block.ts?vue&type=script&lang=ts&external"
export * from "./save-block.ts?vue&type=script&lang=ts&external"

import "./save-block.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__